import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export const getReceipts = async (filters: { [key: string]: any } = {}): Promise<any> => {
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    return await http.get('/receipts' + (queryParams ? '?' + queryParams : ''))
}
